// The one documents preview the record page reads (#11962).
//
// Three readers share this query — the tab-presence probe, the Overview
// card, and the page's own prefetch — and they must fetch identically or two
// fetchers race behind one key. Each asks the record's own documents in ANY
// section: the endpoint's default answers with the documents no related
// vehicle claims, which for a manager whose every document its funds also
// link is nothing, and that "nothing" once hid a populated Documents tab
// and the Overview card behind it (a manager holding dozens of links).
// It reads the same set the Documents tab does: the documents the record
// reaches through its own links. A file merely attached to one of its
// interactions is not among them (#13007).

import { fetchEntityDocuments } from "../api";
import { PREVIEW_LIMIT } from "../Overview/previewData";
import type { EntityDocumentsPage } from "../types";

export const overviewDocumentsQueryKey = (
  kind: string,
  id: string
): readonly [string, string, string, string] =>
  ["rms", "overview-documents", kind, id] as const;

export const fetchOverviewDocuments = (
  kind: string,
  id: string
): Promise<EntityDocumentsPage> =>
  fetchEntityDocuments(kind, id, {
    limit: PREVIEW_LIMIT + 1,
    anySection: true,
  }) as Promise<EntityDocumentsPage>;
